<template>
  <nav id="actions-top" class="wrap">
    <router-link class="btn prev btn-full" :to="back">
      <i class="icon-go"></i>
      Retour
    </router-link>
    <slot></slot>
  </nav>
</template>

<script>
export default {

  data(){
    return {

    }
  },

  props: {
    back:null
  },

  computed: {

  },

  methods: {

  }
}

</script>

<style>

  #actions-top{
    display: flex;
    margin-bottom: 10px;
  }

  #actions-top a{
    cursor: pointer;
  }

  #main-action{
    flex-grow: 2;
    margin-left: 10px;
  }

</style>



// WEBPACK FOOTER //
// ActionBar.vue?2b404e1c